export const fallRule = {
  title: '失陷检测离线包',
  cont: [
    '• 资源包含5w个失陷检测的IOC。',
    '• 内容包含最近流行的热点恶意域名、可信度高的恶意URL、IP、部分国内有影响的公开APT活动等情报信息。',
    '• 可用于本地日志流量的检测和拦截。'
  ]
}
export const intelligenceRule = {
  title: '挖矿情报离线资源包',
  cont: [
    '• 资源包含1W+个热点挖矿情报IOC。',
    '• 内容包含最近流行的热点挖矿相关恶意域名、IP 、HASH、部分挖矿相关的漏洞等情报信息。',
    '• 消费集成后，可以检测或者拦截挖矿行为。'
  ]
}
export const industryArr = ['航空', '农业', '化工', '建筑', '防务', '教育', '能源', '金融', '政府', '健保', '医疗', '制造', '媒体', '非政府', '零售', '半导体', '科技', '通信', '运输', '非特定']
